import React from 'react'
import { CloseOutlined } from '@ant-design/icons'
import { message, Typography } from 'antd'
import './index.less'

const { Paragraph } = Typography

type TProps = {
	errorMsg: string
	key: string
}

const ErrorMessage = ({ errorMsg, key }: TProps) => {
	return (
		<Paragraph className="error-message_wrapper">
			{errorMsg}
			<CloseOutlined className="error-message_close" onClick={() => message.destroy(key)} />
		</Paragraph>
	)
}

export default ErrorMessage
